import React from "react";

export const ProductsData = [
    {
        id: 0,
        slug: "plus",
        name: 'Pabloo Plus',
        subtitle: "1 Users, All Apps",
        monthlyPrice: "$59",
        annualPrice: "$588",
        annualPriceByMonth: "$49",
        advertisedPriceMonth: "$59.00/mo.",
        advertisedFeatures: [
            "Pabloo Store Credit",
            "Shopify integration",
            "Point of sale (POS)"
        ],
        variant: 'Standard account',

        // Price IDs
        priceIdMonth: "price_1POAPBEtOurAbnzKNC4WhV8W",
        priceIdMonthTest: "price_1RCLQWEtOurAbnzKmKc6bYP3",
        priceIdAnnual: "price_1POVwdEtOurAbnzKcFvlNWt6",
        priceIdAnnualTest: "price_1RCLREEtOurAbnzK13Jt9X31",

        // Amounts in cents
        amountMonth: 5900,
        amountAnnual: 58800,
    },
    {
        id: 1,
        slug: "pro",
        name: 'Pabloo Professional',
        subtitle: "1 Users, All Apps",
        monthlyPrice: "$125",
        annualPrice: "$1440",
        annualPriceByMonth: "$120",
        advertisedPriceMonth: "$125.00/mo.",
        advertisedFeatures: [
            "Pabloo Cashback",
            "\"Streak\" bonuses"
        ],
        variant: 'Standard account',

        // Price IDs
        priceIdMonth: "price_1POVySEtOurAbnzKxmdHHZEk",
        priceIdMonthTest: "price_1RCLUvEtOurAbnzKCWVALwAl",
        priceIdAnnual: "price_1POVzPEtOurAbnzKgWNO97Rl",
        priceIdAnnualTest: "price_1RCLVMEtOurAbnzKAo3nljSh",

        // Amounts in cents
        amountMonth: 12500,
        amountAnnual: 144000,
    },
    {
        id: 2,
        slug: "premium",
        name: 'Pabloo Premium',
        subtitle: "1 Users, All Apps",
        monthlyPrice: "$260",
        annualPrice: "$2640",
        annualPriceByMonth: "$220",
        advertisedPriceMonth: "$260.00/mo.",
        advertisedFeatures: [
            "Pabloo Membership",
            "Premium support",
            "Account buy-in"
        ],
        variant: 'Standard account',

        // Price IDs - DONE
        priceIdMonth: "price_1OXhZ6EtOurAbnzK34OqnaOi",
        priceIdMonthTest: "price_1OXfzjEtOurAbnzKiNhLkIKc",
        priceIdAnnual: "price_1RD6jFEtOurAbnzK05JNR2J5",
        priceIdAnnualTest: "price_1RCLMuEtOurAbnzKJblQcv1j",

        // Amounts in cents
        amountMonth: 26000,
        amountAnnual: 264000,
    },

    // ── Onboarding plans (new pricing) ──────────────────────────────────────────
    // annualPrice = yearly billing total; annualPriceByMonth = per-month equivalent shown in UI
    {
        id: 20,
        slug: "starter",
        name: "Starter",
        variant: "Starter plan",
        monthlyPrice: "$49",
        annualPrice: "$468",        // $39 × 12
        annualPriceByMonth: "$39",
        advertisedPriceMonth: "$49.00/mo.",
        // TODO: Replace with live Stripe price IDs once created in dashboard
        priceIdMonth: "price_starter_monthly_TODO",
        priceIdMonthTest: "price_starter_monthly_test_TODO",
        priceIdAnnual: "price_starter_annual_TODO",
        priceIdAnnualTest: "price_starter_annual_test_TODO",

        // Amounts in cents
        amountMonth: 4900,
        amountAnnual: 46800,
    },
    {
        id: 21,
        slug: "growth_s",
        name: "Growth S",
        variant: "Growth plan — S tier",
        monthlyPrice: "$149",
        annualPrice: "$1,428",      // $119 × 12
        annualPriceByMonth: "$119",
        advertisedPriceMonth: "$149.00/mo.",
        // TODO: Replace with live Stripe price IDs once created in dashboard
        priceIdMonth: "price_growth_s_monthly_TODO",
        priceIdMonthTest: "price_growth_s_monthly_test_TODO",
        priceIdAnnual: "price_growth_s_annual_TODO",
        priceIdAnnualTest: "price_growth_s_annual_test_TODO",

        // Amounts in cents
        amountMonth: 14900,
        amountAnnual: 142800,
    },
    {
        id: 22,
        slug: "growth_m",
        name: "Growth M",
        variant: "Growth plan — M tier",
        monthlyPrice: "$299",
        annualPrice: "$2,868",      // $239 × 12
        annualPriceByMonth: "$239",
        advertisedPriceMonth: "$299.00/mo.",
        // TODO: Replace with live Stripe price IDs once created in dashboard
        priceIdMonth: "price_growth_m_monthly_TODO",
        priceIdMonthTest: "price_growth_m_monthly_test_TODO",
        priceIdAnnual: "price_growth_m_annual_TODO",
        priceIdAnnualTest: "price_growth_m_annual_test_TODO",

        // Amounts in cents
        amountMonth: 29900,
        amountAnnual: 286800,
    },
    {
        id: 23,
        slug: "growth_l",
        name: "Growth L",
        variant: "Growth plan — L tier",
        monthlyPrice: "$549",
        annualPrice: "$5,268",      // $439 × 12
        annualPriceByMonth: "$439",
        advertisedPriceMonth: "$549.00/mo.",
        // TODO: Replace with live Stripe price IDs once created in dashboard
        priceIdMonth: "price_growth_l_monthly_TODO",
        priceIdMonthTest: "price_growth_l_monthly_test_TODO",
        priceIdAnnual: "price_growth_l_annual_TODO",
        priceIdAnnualTest: "price_growth_l_annual_test_TODO",

        // Amounts in cents
        amountMonth: 54900,
        amountAnnual: 526800,
    },

    {
        id: 10,
        slug: "sms_alerts",
        name: 'SMS alerts.',
        subtitle: "Implement SMS alerts to notify customers of account updates. More than 62% of our members have enabled SMS to drive attempt customers.",
        monthlyPrice: "$12",
        annualPrice: "$144",
        annualPriceByMonth: "$12",
        advertisedPriceMonth: "$12.00/mo.",
        advertisedFeatures: [
            "Cashback Credit"
        ],
        variant: 'Standard',

        // Price IDs
        priceIdMonth: "price_1RD6mREtOurAbnzKdsLaOvtE",
        priceIdMonthTest: "price_1RCLY4EtOurAbnzKr36lLCbl",
        priceIdAnnual: "price_1RD6mvEtOurAbnzK2cT3eeTb",
        priceIdAnnualTest: "price_1RCLYMEtOurAbnzK6Qjk0Cjy",

        // Amounts in cents
        amountMonth: 1200,
        amountAnnual: 14400,
    },
    {
        id: 11,
        slug: "webhooks",
        name: 'Webhook receiver.',
        subtitle: "Subscribe to webhook events for complete control into all store credit transactions. For developers.",
        monthlyPrice: "$16",
        annualPrice: "$192",
        annualPriceByMonth: "$16",
        advertisedPriceMonth: "$16.00/mo.",
        advertisedFeatures: [
            "Cashback Credit"
        ],
        variant: 'Standard',

        // Price IDs
        priceIdMonth: "price_1RD6nnEtOurAbnzK4CkMZv4m",
        priceIdMonthTest: "price_1RCLZdEtOurAbnzKQdTCR0vW",
        priceIdAnnual: "price_1RD6oCEtOurAbnzKzkBN4KSa",
        priceIdAnnualTest: "price_1RCLaEEtOurAbnzKWDTjRMQX",

        // Amounts in cents
        amountMonth: 1600,
        amountAnnual: 19200,
    },
]

export const AddOnProducts = [
    {
        id: 10,
        slug: "sms_alerts",
        name: 'SMS alerts.',
        subtitle: "Implement SMS alerts to notify customers of account updates. More than 62% of our members have enabled SMS to drive repeat customers.",
        monthlyPrice: "$12",
        annualPrice: "$144",
        annualPriceByMonth: "$12",
        variant: 'Standard',

        // Price IDs
        priceIdMonth: "price_1RD6mREtOurAbnzKdsLaOvtE",
        priceIdMonthTest: "price_1RCLY4EtOurAbnzKr36lLCbl",
        priceIdAnnual: "price_1RD6mvEtOurAbnzK2cT3eeTb",
        priceIdAnnualTest: "price_1RCLYMEtOurAbnzK6Qjk0Cjy"
    },
    {
        id: 11,
        slug: "webhooks",
        name: 'Webhook receiver.',
        subtitle: "Subscribe to webhook events for complete control into all store credit transactions. For developers.",
        monthlyPrice: "$16",
        annualPrice: "$192",
        annualPriceByMonth: "$16",
        variant: 'Standard',

        // Price IDs
        priceIdMonth: "price_1RD6nnEtOurAbnzK4CkMZv4m",
        priceIdMonthTest: "price_1RCLZdEtOurAbnzKQdTCR0vW",
        priceIdAnnual: "price_1RD6oCEtOurAbnzKzkBN4KSa",
        priceIdAnnualTest: "price_1RCLaEEtOurAbnzKWDTjRMQX"
    },
]


export const productFeatures = [
        // PLUS
        {
            id: 0,
            title: "Unlimited deposits, unlimited withdraws",
            subtitle: "Simple, flat-rate pricing. No hidden fees per order.",
            tier: "plus",

            subsection: "",  // Cashback, Memberships, Store Credit Refunds, Main
            showOnPricingPage: false,
            showOnFeaturePage: false,
        },
        {
            title: "Immediate refunds with credit",
            subtitle: "Refund any order in full or in part with store credit. Also supports refunding more than the original amount for a better refund experience.",
            tier: "plus"
        },
        {
            title: "Gift cards, discount codes, and custom offers",
            subtitle: "Customers can stack store credit with discount codes, gift cards, promotional codes, and custom offers.",
            tier: "plus"
        },
        {
            title: "Credit expiration and product exclusion",
            subtitle: "Maintain control over your store credit program by establishing expiration timelines and defining any product exclusions.",
            tier: "plus"
        },
        {
            title: "Shipping and Sales Tax",
            subtitle: "Customers are able to apply their store credit towards their shipping fees and sales tax during their purchases.",
            tier: "plus"
        },
        {
            title: "Dashboards and granular data tracking",
            subtitle: "",
            tier: "plus"
        },
        {
            title: "Direct integrations for Shopify and WooCommerce",
            subtitle: "Pabloo integrates seamlessly with the leading e-commerce platforms.",
            tier: "plus"
        },

        {
            title: "Loyalty program for north star metrics",
            subtitle: "The Pabloo loyalty program incentivizes customer sign-ups, referrals, and purchases.",
            tier: "plus"
        },
        {
            title: "White labeled and customizable",
            subtitle: "Customizable views to perfectly match your shop's theme and branding, ensuring a flawless experience across all devices.",
            tier: "plus"
        },
        {
            title: "Email notifications",
            subtitle: "Customers are kept informed every time their store credit is added, deducted, or earn cashback.",
            tier: "plus"
        },


        // PROFESSIONAL
        {
            title: "Email & SMS notifications",
            subtitle: "Customers are kept informed every time their store credit is added, deducted, or earn cashback.",
            tier: "pro"
        },
        {
            title: "Save documents local",
            subtitle: "All bookkeeping data can be rendered locally for further analysis and integration with downstream applications.",
            tier: "pro"
        },

        {
            title: "Revert any completed transaction",
            subtitle: "Handles any error you make when making a deposit or withdraw. Allows you revert store credit changes, including purchases.",
            tier: "pro"
        },
        {
            title: "Currency Retailing Professional",
            subtitle: "Your business can legally sell store credit to customers, offering customers flexible payment options and fostering long-term brand engagement.",
            tier: "pro"
        },

        {
            title: "Opt-in affiliate program",
            subtitle: "Each participating customer has an affiliate link; a portion of each sale generated through the link goes back to the affiliate.",
            tier: "pro"
        },

        {
            title: "AI Abandoned cart solution (2.5x increase in checkout)",
            subtitle: "Recover lost sales with our AI-powered abandoned cart solution (Boosts checkout rates by 2.3x).",
            tier: "pro"
        },
        {
            title: "Interactive data with Pabloo AI chat",
            subtitle: "Ask your data anything with our AI assistant.",
            tier: "pro"
        },
        {
            title: "AI tool to reengage dormant customers",
            subtitle: "Analyzes expected Customer Lifetime Value (CLTV) to determine the ideal store credit amount to gift each customer, driving repeat purchases within 60 days and optimizing long-term customer value.",
            tier: "pro"
        },
    ]
